import React, { useContext } from "react";
import { useLocation } from "react-router-dom";

import { Context } from "../../../index";
import { resolveLang, withLang } from "../../../i18n/routesLang";

import ToolSeoPageTemplate from "../../../components/seo/seoTemplates/ToolSeoPageTemplate";
import { buildSeoPayload } from "../../../components/seo/buildSeoPayload/buildSeoPayload";

import { pickPricingPublicPageT } from "./Pricing_Public_Page.lang";
import Pay from "../Pay";

import { PRICING_ROUTE } from "../../../utils/consts";

const PricingPublicPage = () => {
    const { user } = useContext(Context);
    const location = useLocation();

    const lang = resolveLang({
        pathname: location.pathname,
        storeLang: user?.lang,
    });

    const t = pickPricingPublicPageT(lang);

    const PATH = PRICING_ROUTE || "/pricing";
    const pageUrl = `https://virtalibry.com${withLang(PATH, lang)}`;

    const seo = buildSeoPayload({ t, pageUrl });

    return (
        <ToolSeoPageTemplate
            seo={seo}
            hero={t.hero}
            blocks={t.blocks}
            textMode="pricingPublic"
            tool={<Pay />}
            lang={lang}
            pageKey="pricingPublic"
        />
    );
};

export default PricingPublicPage;